import matter from 'gray-matter';
import { Buffer } from 'buffer';
import { useState, useEffect } from 'react';

// Polyfill Buffer for browser
window.Buffer = Buffer;

// List of post files to load (add new posts here)
const postFiles = [

];

// Function to generate a deterministic gradient from a string
export function generateGradient(title) {
  // Simple hash function
  let hash = 0;
  for (let i = 0; i < title.length; i++) {
    hash = title.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  // Generate two vibrant colors
  const hue1 = Math.abs(hash % 360);
  const hue2 = Math.abs((hash * 7) % 360);
  
  // Use HSL for vibrant colors with good saturation and lightness
  const color1 = `hsl(${hue1}, 70%, 50%)`;
  const color2 = `hsl(${hue2}, 70%, 50%)`;
  
  // Create gradient angle
  const angle = Math.abs(hash % 360);
  
  return `linear-gradient(${angle}deg, ${color1}, ${color2})`;
}

function normalizePostDate(date) {
  if (!date) return '';

  if (date instanceof Date) {
    return date.toISOString().slice(0, 10);
  }

  const value = String(date).trim();
  const isoMatch = value.match(/^(\d{4}-\d{2}-\d{2})/);
  if (isoMatch) {
    return isoMatch[1];
  }

  return value;
}

// Process a markdown file
export function processMarkdown(rawContent, slug) {
  const { data, content } = matter(rawContent);
  
  return {
    slug,
    title: data.title || 'Untitled',
    date: normalizePostDate(data.date),
    tags: data.tags || [],
    excerpt: data.excerpt || '',
    thumbnail: data.thumbnail || null,
    gradient: generateGradient(data.title || slug),
    content,
  };
}

// Hook to load blog posts
export function useBlogPosts() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadPosts() {
      try {
        const loadedPosts = await Promise.all(
          postFiles.map(async (filename) => {
            const slug = filename.replace('.md', '');
            const response = await fetch(`/posts/${filename}`);
            const content = await response.text();
            return processMarkdown(content, slug);
          })
        );
        
        // Sort by date (newest first)
        loadedPosts.sort((a, b) => new Date(b.date) - new Date(a.date));
        setPosts(loadedPosts);
      } catch (error) {
        console.error('Error loading posts:', error);
      } finally {
        setLoading(false);
      }
    }

    loadPosts();
  }, []);

  return { posts, loading };
}

